/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Section } from '@spotahome/ui-library';
import { getPagePath, trans, useSoyuzLocales } from '@spotahome/soyuz/client';

import withInViewEvent from '@spotahome/ui-library/src/tenant/components/withInViewEvent';
import useHorizontalDrag from '@spotahome/ui-library/src/hooks/useHorizontalDrag';
import { getNewCountryTranslationByIsoCode } from '@spotahome/ui-library/src/tenant/components/SearchBreadcrumbs/getCountryUrl';

import { LANDING_SECTIONS } from '@spotahome/ui-library/src/tenant/components/utils/seoConstants';
import CityList from '@spotahome/ui-library/src/tenant/components/CityList';

import City from './City';

// styles
import './CitiesShowcase.scss';

const CitiesShowcase = ({ carouselCities, listCities }) => {
  const {
    containerRef,
    isDragging,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd
  } = useHorizontalDrag({
    onMoveStart: () => {},
    onMove: () => {}
  });

  const { current: locale } = useSoyuzLocales();

  const handleCityClick = cityId => e => {
    e.preventDefault();
    e.stopPropagation();
    if (isDragging()) {
      return;
    }

    const path = getPagePath('marketplace.free-search', {
      params: { locationString: cityId }
    });

    window.location.href = path;
  };

  const handleCountryClick = countryIsoCode => e => {
    e.preventDefault();
    e.stopPropagation();
    if (isDragging()) {
      return;
    }

    const path = getNewCountryTranslationByIsoCode(countryIsoCode, locale);

    window.location.href = path;
  };

  return (
    <Section background="light" className="cities-showcase__container">
      <Section background="light" className="cities-showcase__top-cities">
        <div className="cities-showcase">
          <div className="cities-showcase__header">
            <h2 className="cities-showcase__header-title">
              {trans('landingpage.label.cities')}
            </h2>
          </div>
          <ul
            className="cities-showcase__carousel-list"
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            ref={containerRef}
          >
            {carouselCities.map(city => (
              <li key={city.id} className="cities-showcase__carousel-item">
                <City
                  id={city.id}
                  cityName={city.cityName}
                  countryId={city.country.countryId.toLowerCase()}
                  countryPageUrl={getNewCountryTranslationByIsoCode(
                    city.country.countryIsoCode,
                    locale
                  )}
                  onClick={handleCityClick(city.id)}
                  onCountryClick={handleCountryClick(
                    city.country.countryIsoCode
                  )}
                />
              </li>
            ))}
          </ul>
        </div>
      </Section>
      <Section background="light" className="cities-showcase__other-cities">
        <CityList cities={listCities} />
      </Section>
    </Section>
  );
};

export default withInViewEvent(LANDING_SECTIONS.citiesShowcase)(CitiesShowcase);
